/**
 * Component for Copyright
 * Component used to render the Copyright
 *
 * @module components
 */

import PropTypes from 'prop-types';
import React from 'react';

import { ContentSections } from '../../../constants/ContentSections';
import { parseCopyrightInfo } from '../../../lib/StringUtils';
import { withVisibilityLogger } from '../../VisibilityLogger/VisibilityLogger';

import './Copyright.scss';

export class Copyright extends React.Component {
  static propTypes = {
    copyrights: PropTypes.string,
  };

  renderCopyrightInfo = () => {
    return parseCopyrightInfo(this.props.copyrights).map((copyright, i) => {
      return (
        <p className='Copyright__text' key={i}>
          {copyright}
        </p>
      );
    });
  };

  render() {
    return <div className='Copyright'>{this.renderCopyrightInfo()}</div>;
  }
}

export const CopyrightWithLogger = withVisibilityLogger({
  contentSection: ContentSections.COPYRIGHT,
})(Copyright);

export default Copyright;
